import React from "react";
import {
  DatePicker,
  Select,
  Input,
  Button,
  Table,
  Modal,
  Popover,
  Tabs,
} from "antd";
import moment from "moment";
import { forEach, get, filter, map, find, set } from "lodash";
import consts from "../consts";
import BigNumber from "bignumber.js";
import utils from "../common/utils";

import FavoriteStar from "./common/FavoriteStar";
import DisplayControl from "./DisplayControl";

const { Option } = Select;
const { RangePicker } = DatePicker;
const { Search } = Input;
const { TabPane } = Tabs;
const ALL = "ALL";
const dateFormat = "DD/MM/YYYY";
moment.locale("vi");
const { COLOR_BUY, COLOR_SELL } = consts;
class AffiliateStatistic extends React.Component {
  constructor(props) {
    super(props);

    this.filter = {
      startTime: "",
      endTime: "",
    };
    this.mapLevel = {
      startTime: "",
      endTime: "",
    };
    this.state = {
      totalCount: 0,
      currentPage: 1,
      isLoading: false,
      visible: false,
      pubkey_trans: "",
      clsData: {},
      partnerData: {},
      level: "",
      listCoin: {},
      expandedRowKeys: [],
      onDateMapLevel: true,
      currentPageTrans: 1,
      currentPageOrderTrans: 1,
      totalCountPartner: 0,
      totalCountUser: 0,
      countTrans: 0,
      countOrderTrans: 0,
    };
    this.newListPartners = {};
    this.newPartnerData = {};
    this.level = {};
    this.newObj = {};
  }

  commissionColumns = [
    {
      title: "Đồng",
      dataIndex: "symbol",
      key: "symbol",
      render: (coin, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                width: "45px",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  backgroundImage: `url(${item.icon_image})`,
                  height: "25px",
                  width: "25px",
                  backgroundSize: "contain",
                  marginRight: "20px",
                  display: "block",
                  marginTop: 3,
                  backgroundRepeat: "no-repeat",
                }}
                alt={coin}
              ></div>
            </div>
            <div
              style={{
                width: "100px",
                textAlign: "left",
                color: "#000",
                marginTop: "3px",
                fontWeight: 500,
                lineHeight: "28px",
              }}
            >
              {coin}
            </div>
            <div
              style={{
                width: "230px",
                textAlign: "left",
                fontSize: "16px",
                lineHeight: "28px",
                color: "#76808F",
                marginTop: "3px",
              }}
            >
              {item.name ?? ""}
            </div>
          </div>
        );
      },
    },
    {
      title: "Số lượng",
      dataIndex: "value",
      key: "value",
      render: utils.formatCurrency,
    },
  ];

  columns = [
    {
      title: "Gmail",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Public key",
      dataIndex: "pubkey",
      key: "pubkey",
      render: (text) => (
        <div>
          <DisplayControl
            permission_link_screen={[
              {
                permission: consts.AUTH.FAVORITE__AFFILIATE,
                action: consts.CONTROLS.POST,
              },
              {
                permission: consts.AUTH.FAVORITE__AFFILIATE__pUBKEY,
                action: consts.CONTROLS.DELETE,
              },
            ]}
          >
            <FavoriteStar
              initialValue={
                this.props.favorite.findIndex((item) => item.user === text) ===
                -1
                  ? false
                  : true
              }
              onClick={(event) => {
                event.stopPropagation();
              }}
              onChange={(value) => {
                let params = { pubkey: text };

                if (value) {
                  this.props.onCreateFavorite(params);
                } else {
                  this.props.onRemoveFavorite(params);
                }
              }}
            />
          </DisplayControl>

          {text}
        </div>
      ),
    },
    {
      align: "center",
      title: "Số lượng người đã mời vào sàn",
      dataIndex: "count",
      key: "count",
    },
    {
      align: "center",
      title: "Tổng lượng hoa hồng (USDT)",
      dataIndex: "list_coin_arr",
      key: "list_coin_arr",
      render: (listCoin) => (
        <div className="d-flex align-items justify-evenly">
          <div>{utils.formatCurrency(this.getTotalBTCBalance(listCoin))}</div>
          <div>
            <Button onClick={(event) => this.showModal(event, listCoin)}>
              Chi tiết
            </Button>
          </div>
        </div>
      ),
    },
  ];

  transCols = () => [
    {
      title: "Tài khoản",
      dataIndex: "pubkey",
      key: "pubkey",
      // render: (pubkey) => <div
      //   className='ellipsis'
      //   title={pubkey}
      // >{pubkey}</div>
      ellipsis: true,
    },
    {
      align: "center",
      title: "Đồng",
      dataIndex: "currency",
      key: "currency",
      width: 80,
    },
    {
      align: "center",
      title: "Thời gian",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Địa chỉ gửi",
      dataIndex: "from_address",
      key: "from_address",
      // render: (fromAddr) => <div
      //   className='ellipsis'
      //   title={fromAddr}
      // >{fromAddr}</div>
      ellipsis: true,
    },
    {
      title: "Địa chỉ nhận",
      dataIndex: "to_address",
      key: "to_address",
      // render: (toAddr) => <div
      //   className='ellipsis'
      //   title={toAddr}
      // >{toAddr}</div>
      ellipsis: true,
    },
    {
      align: "center",
      title: "Số tiền giao dịch",
      dataIndex: "total",
      key: "total",
      width: 120,
      render: (total) =>
        total === undefined ? "" : utils.formatCurrency(total),
    },
    {
      align: "center",
      title: "Phí giao dịch",
      dataIndex: "fee",
      key: "fee",
      width: 100,
    },
    {
      align: "center",
      title: "Số tiền nhận được",
      dataIndex: "amount",
      key: "amount",
      width: 120,
    },
    {
      align: "center",
      title: "Loại",
      dataIndex: "type",
      key: "type",
      width: 80,
      render: (type) => (
        <div
          style={{ color: type === 0 ? consts.COLOR_BUY : consts.COLOR_SELL }}
        >
          {type !== undefined ? utils.parseTransType(type) : ""}
        </div>
      ),
    },
    {
      align: "center",
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      width: 100,
    },
  ];

  orderTransCols = () => [
    {
      title: "Tài Khoản",
      width: 300,
      ellipsis: true,
      render: (tranType, orderTrans) => (
        <div
          className="ellipsis"
          // style={{
          //   overflow: 'hidden',
          //   whiteSpace: 'nowrap',
          //   width: 260,
          //   textOverflow: 'ellipsis',
          // }}
          title={
            utils.isBuyOrder(tranType)
              ? orderTrans.buyer_pubkey
              : orderTrans.seller_pubkey
          }
        >
          {utils.isBuyOrder(tranType)
            ? orderTrans.buyer_pubkey
            : orderTrans.seller_pubkey}
        </div>
      ),
    },
    {
      align: "center",
      title: "Thời gian",
      dataIndex: "created_at",
      key: "created_at",
      render: (createdAt) =>
        createdAt
          ? utils.formatTimeFromUnix(createdAt, "DD/MM/YYYY HH:mm")
          : "",
    },
    {
      align: "center",
      title: "Loại giao dịch",
      dataIndex: "transaction_type",
      key: "transaction_type",
      // render: (transactionType) => utils.parseOrderType(transactionType),
      render: (tranType) => (
        <div
          style={{
            color: utils.isBuyOrder(tranType) ? COLOR_BUY : COLOR_SELL,
          }}
        >
          {utils.parseTradeType(tranType)}
        </div>
      ),
    },
    {
      align: "center",
      title: "Cặp",
      dataIndex: "pair",
      key: "pair",
    },
    {
      align: "center",
      title: "Giá",
      dataIndex: "price",
      key: "price",
      render: (price) =>
        price !== undefined ? utils.formatCurrency(price) : "",
    },
    {
      align: "center",
      title: "Số lượng",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      align: "center",
      title: "Tổng số",
      dataIndex: "amount",
      key: "amount",
    },
  ];

  showModal = (event, listCoin) => {
    event.stopPropagation();
    this.setState({
      visible: true,
      listCoin,
    });
  };

  columnsDetail = [
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
    },
    {
      title: "Giá trị",
      dataIndex: "commission",
      key: "commission",
      render: utils.formatCurrency,
    },
  ];

  columnsPartner = [
    {
      title: "Người được giới thiệu",
      dataIndex: "partner",
      key: "partner",
      render: (partner) => (
        <Popover content={this.partnerContent(partner)} trigger="click">
          <div
            className="pointer"
            onClick={() => {
              this.setState({
                currentPageOrderTrans: 0,
                currentPageTrans: 0,
              });
              this.fetchOrderTrans(0, 5, partner);
              this.fetchTrans(0, 5, partner);
            }}
          >
            {partner}
          </div>
        </Popover>
      ),
    },
  ];

  fetchTrans = (pos = 0, count = 5, partner) => {
    this.props.onFetchUserTransHistoryAction(
      {
        trans_type: -1,
        pos,
        count,
        pubkey: partner,
      },
      (totalCount) => this.setState({ countTrans: totalCount })
    );
  };

  fetchOrderTrans = (pos = 0, count = 5, partner) => {
    this.props.onFetchUserOrderTransHistoryAction(
      {
        pos,
        count,
        pubkey: partner,
      },
      (totalCount) => this.setState({ countOrderTrans: totalCount })
    );
  };

  partnerContent = (partner) => (
    <Tabs defaultActiveKey="1">
      <TabPane tab="Giao dịch" key="1">
        <Table
          style={{ maxWidth: "1200px" }}
          columns={this.transCols()}
          dataSource={this.props.trans || []}
          pagination={{
            current: this.state.currentPageTrans || 1,
            onChange: (page, pageSize) => {
              this.fetchTrans((page - 1) * pageSize, pageSize, partner);
              this.setState({ currentPageTrans: page });
            },
            defaultPageSize: 5,
            total: this.state.countTrans,
            hideOnSinglePage: true,
          }}
          bordered
        />
      </TabPane>
      <TabPane tab="Lịch sử lệnh khớp" key="2">
        <Table
          style={{ maxWidth: "1200px" }}
          columns={this.orderTransCols()}
          dataSource={this.props.orderTransactions || []}
          pagination={{
            current: this.state.currentPageOrderTrans || 1,
            onChange: (page, pageSize) => {
              this.fetchOrderTrans((page - 1) * pageSize, pageSize, partner);
              this.setState({ currentPageOrderTrans: page });
            },
            defaultPageSize: 5,
            total: this.state.countOrderTrans,
            hideOnSinglePage: true,
          }}
          bordered
        />
      </TabPane>
    </Tabs>
  );

  componentDidMount() {
    this.props.fetchCommissionAll();
    this.props.fetchCommissionUsers(
      {
        pos: 0,
        count: consts.DEFAULT_PAGE_SIZE,
      },
      (totalCountUser) =>
        this.setState({
          totalCountUser,
        })
    );
    this.props.fetchTotalReferal((totalCount) => this.setState({ totalCount }));
    this.props.onFetchFavorite({
      pos: 0,
      count: consts.DEFAULT_PAGE_SIZE,
    });
  }

  showOption = () => {
    return map(this.props.arrCoins || [], (item, index) => {
      return (
        <Option key={index} value={item.coin}>
          {item.coin}
        </Option>
      );
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  handleOk = () => {
    this.setState({
      visible: false,
    });
  };

  onChangeDate = (params) => {
    const [startTime, endTime] = params || [null, null];
    if (startTime !== null && endTime !== null) {
      this.filter.startTime = startTime.startOf("day").unix();
      this.filter.endTime = endTime.endOf("day").unix();
      this.fetchData();
    } else {
      this.filter.startTime = "";
      this.filter.endTime = "";
      this.props.fetchCommissionAll();
    }
  };

  onChangeDateUser = (params) => {
    const [startTime, endTime] = params || [null, null];

    if (startTime !== null && endTime !== null) {
      let start = startTime.startOf("day").toString();
      let dateEnd = endTime.endOf("day").toString();
      this.filter.startTime = moment(start).unix();
      this.filter.endTime = moment(dateEnd).unix();
      this.fetchDataUser();
    } else {
      this.filter.startTime = "";
      this.filter.endTime = "";
      this.props.fetchCommissionUser({
        pos: 0,
        count: consts.DEFAULT_PAGE_SIZE,
      });
    }
  };

  onChangeDateMapLevel = (date) => {
    if (date) {
      this.mapLevel = {
        ...this.mapLevel,
        startTime: date[0].startOf("hour").unix(),
        endTime: date[1].endOf("hour").unix(),
      };
    } else {
      this.mapLevel = {
        ...this.mapLevel,
        startTime: "",
        endTime: "",
      };
    }
    this.props.fetchListMapLevel({
      pubkey: this.state.pubkey_trans,
      ...this.mapLevel,
    });
  };

  onFilterCoin = (coinName) => {
    this.setState({ coinName });
  };

  fetchData = () => {
    this.props.fetchCommissionByTime(this.filter);
  };

  fetchDataUser = (pos, count = consts.DEFAULT_PAGE_SIZE) => {
    this.setState({ isLoading: true });
    this.props.fetchCommissionUserByTime(
      {
        ...this.filter,
        pos,
        count,
      },
      (totalCount) =>
        this.setState({
          totalCount,
          isLoading: false,
        })
    );
  };

  getTotalBTCBalance = (balances = []) => {
    let mapCurrencyMarkets = this.props.mapCurrencyMarkets;
    let filterBalances = {};
    let sumBalance = new BigNumber(0);
    let coin;

    forEach(balances, (item) => {
      if (item.value !== 0) {
        coin = item.name_coin;
        filterBalances[item.name_coin] = item;
      }
    });

    forEach(filterBalances, (balance) => {
      coin = balance.name_coin;
      let checkCoinHaveLastPrice = false;
      let currencyMarket = get(mapCurrencyMarkets, `USDT.${coin}`, false);
      if (currencyMarket) {
        sumBalance = sumBalance.plus(
          new BigNumber(filterBalances[coin].value).times(
            currencyMarket.last_price
          )
        );
        checkCoinHaveLastPrice = true;
      } else {
        let coins = filter(
          this.props.setting.coinSettings,
          (coinSetting) => coinSetting.coin === coin
        );

        for (let i = 0; i < coins.length; i++) {
          let { coin, currency } = coins[i];
          let currencyMarket = get(
            mapCurrencyMarkets,
            `${currency}.${coin}`,
            false
          );
          if (currencyMarket) {
            sumBalance = sumBalance.plus(
              new BigNumber(filterBalances[coin].value)
                .times(currencyMarket.last_price)
                .times(get(mapCurrencyMarkets, `USDT.${currency}`).last_price)
            );

            checkCoinHaveLastPrice = true;
            break;
          }
        }
      }

      if (checkCoinHaveLastPrice === false) {
        sumBalance = sumBalance.plus(filterBalances[coin].value);
      }
    });

    sumBalance = sumBalance.plus(filterBalances["USDT"]?.value || 0);

    return sumBalance.toNumber();
  };

  getBTCBalance = (balances) => {
    let currencyMarket = find(
      this.props.currencyMarkets["USDT"],
      (currencyMarket) => currencyMarket.coin === "BTC"
    );
    if (!currencyMarket) {
      return 0;
    }

    return this.getTotalBTCBalance(balances) / currencyMarket.last_price;
  };
  // netply, iis config

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.listMapLevel !== nextProps.listMapLevel) {
      this.newObj[this.state.pubkey_trans] = nextProps.listMapLevel;
      this.setState({
        clsData: {
          ...this.state.clsData,
          ...this.newObj,
        },
      });
    }
    if (this.props.listPartners !== nextProps.listPartners) {
      this.level = {
        ...this.level,
        ...{
          [this.state.level]: {
            data: nextProps.listPartners,
            totalCountPartner: this.props.totalCountPartner,
          },
        },
      };
      this.newPartnerData = {
        ...this.newPartnerData,
        ...{
          [this.state.pubkey_trans]: {
            ...this.level,
          },
        },
      };
      this.setState({
        partnerData: {
          ...this.state.partData,
          ...this.newPartnerData,
        },
      });
    }
  }

  collapseTablePubkeyLevel = (item, record) => {
    return (
      <div>
        <Table
          columns={this.columnsPartner}
          dataSource={get(this.state.partnerData, [
            record.pubkey,
            item.level,
            "data",
          ])}
          pagination={{
            current: get(
              this.newListPartners,
              [record.pubkey, item.level, "currentPagePartner"],
              1
            ),
            onChange: (page, pageSize) => {
              this.props.fetchListPartners(
                {
                  pubkey: record.pubkey,
                  level: item.level,
                  pos: (page - 1) * pageSize,
                  count: pageSize,
                },
                (totalCountPartner) => {
                  set(
                    this.newPartnerData,
                    [record.pubkey, item.level, "totalCountPartner"],
                    totalCountPartner
                  );
                  set(
                    this.newPartnerData,
                    [record.pubkey, item.level, "currentPagePartner"],
                    page
                  );
                  this.setState({
                    partnerData: this.newPartnerData,
                  });
                }
              );
            },
            defaultPageSize: consts.DEFAULT_PAGE_SIZE,
            total: get(
              this.newListPartners,
              [record.pubkey, item.level, "totalCountPartner"],
              0
            ),
            hideOnSinglePage: true,
          }}
        />
      </div>
    );
  };

  collapseTablePubkey = (record) => {
    return (
      <div>
        <Table
          key={record.pubkey}
          columns={this.columnsDetail}
          dataSource={this.state.clsData[record.pubkey] || []}
          rowClassName="pointer"
          pagination={false}
          expandable={{
            expandRowByClick: true,
            expandedRowRender: (item) =>
              this.collapseTablePubkeyLevel(item, record),
            onExpand: (expanded, item) =>
              expanded
                ? (this.setState({
                    level: item.level,
                  }),
                  this.props.fetchListPartners({
                    pubkey: record.pubkey,
                    level: item.level,
                    pos: 0,
                    count: consts.DEFAULT_PAGE_SIZE,
                  }))
                : "",
          }}
        />
      </div>
    );
  };

  onExpandRow = (expanded, record) => {
    this.mapLevel = {
      startTime: "",
      endTime: "",
    };
    if (expanded) {
      this.setState({
        pubkey_trans: record.pubkey,
        expandedRowKeys: [record.pubkey],
        onDateMapLevel: false,
      });
      this.props.fetchListMapLevel({
        pubkey: record.pubkey,
      });
    } else {
      this.setState({
        expandedRowKeys: [],
        onDateMapLevel: true,
      });
    }
  };

  onChangeTab = (key) => {
    switch (key) {
      // TODO refactor code here
      case "1": {
        this.props.fetchCommissionUsers(
          {
            pos: 0,
            count: consts.DEFAULT_PAGE_SIZE,
          },
          (totalCountUser) =>
            this.setState({
              totalCountUser,
            })
        );
        this.props.onFetchFavorite({
          pos: 0,
          count: consts.DEFAULT_PAGE_SIZE,
        });
        break;
      }
      case "2": {
        this.props.onFetchFavoriteDetail({
          pos: 0,
          count: consts.DEFAULT_PAGE_SIZE,
        });
        this.props.onFetchFavorite({
          pos: 0,
          count: consts.DEFAULT_PAGE_SIZE,
        });
        break;
      }
    }
  };

  render() {
    return (
      <div className="withdrawalHistory">
        <div className="d-flex space-between">
          <h2>Thống kê chương trình giới thiệu</h2>
          <h3 className="mr-medium">
            Tổng số người giới thiệu: {this.state.totalCount}
          </h3>
        </div>

        <div
          style={{
            justifyContent: "space-between",
            display: "flex",
            marginBottom: "30px",
          }}
        >
          <RangePicker
            // placeholder={['Bắt đầu','Kết thúc']}
            onChange={this.onChangeDate}
            format={dateFormat}
            style={{ width: "30%" }}
          />
        </div>
        <div style={{ maxWidth: "800px" }}>
          <Table
            dataSource={this.props.commissions}
            columns={this.commissionColumns}
            pagination={{
              defaultPageSize: 5,
              total: (this.props.coins || []).length,
              hideOnSinglePage: true,
            }}
          />
        </div>

        <div className="mt-medium mb-medium" />

        <div>
          <div>
            <h2>Thống kê chương trình giới thiệu cho người dùng</h2>
          </div>
          <div className="mb-medium d-flex space-between">
            <RangePicker
              // placeholder={['Bắt đầu','Kết thúc']}
              onChange={this.onChangeDateMapLevel}
              format={"DD/MM/YYYY HH"}
              style={{ width: "30%" }}
              disabled={this.state.onDateMapLevel}
              value={[
                this.mapLevel.startTime
                  ? moment.unix(this.mapLevel.startTime)
                  : "",
                this.mapLevel.endTime ? moment.unix(this.mapLevel.endTime) : "",
              ]}
              showTime
            />
          </div>
          <div>
            <Tabs onChange={this.onChangeTab}>
              <TabPane tab="Tất cả" key={1}>
                <Table
                  dataSource={this.props.usersCommission}
                  columns={this.columns}
                  pagination={{
                    current: this.state.currentPage,
                    onChange: (page, pageSize) => {
                      this.props.fetchCommissionUsers(
                        {
                          pos: (page - 1) * pageSize,
                          count: pageSize,
                        },
                        (totalCountUser) =>
                          this.setState({
                            totalCountUser,
                            currentPage: page,
                          })
                      );
                      this.props.onFetchFavorite({
                        pos: (page - 1) * pageSize,
                        count: pageSize,
                      });
                    },
                    defaultPageSize: consts.DEFAULT_PAGE_SIZE,
                    total: this.state.totalCountUser,
                    hideOnSinglePage: true,
                  }}
                  expandable={{
                    expandRowByClick: true,
                    expandedRowRender: (record) =>
                      this.collapseTablePubkey(record),
                    rowExpandable: (record) => record.list_coin_arr.length > 0,
                    expandedRowKeys: this.state.expandedRowKeys,
                    onExpand: (expanded, record) =>
                      this.onExpandRow(expanded, record),
                  }}
                />
              </TabPane>
              <TabPane tab="Ưa thích" key={2}>
                <Table
                  dataSource={this.props.favoriteDetail}
                  columns={this.columns}
                  pagination={{
                    current: this.state.currentPage,
                    onChange: (page, pageSize) => {
                      this.props.onFetchFavoriteDetail({
                        pos: (page - 1) * pageSize,
                        count: pageSize,
                      });
                    },
                    defaultPageSize: consts.DEFAULT_PAGE_SIZE,
                    total: this.state.totalCountUser,
                    hideOnSinglePage: true,
                  }}
                  expandable={{
                    expandRowByClick: true,
                    expandedRowRender: (record) =>
                      this.collapseTablePubkey(record),
                    rowExpandable: (record) => record.list_coin_arr.length > 0,
                    expandedRowKeys: this.state.expandedRowKeys,
                    onExpand: (expanded, record) =>
                      this.onExpandRow(expanded, record),
                  }}
                />
              </TabPane>
            </Tabs>
          </div>
        </div>
        <Modal
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={[
            <></>,
            <Button type="primary" onClick={this.handleOk}>
              Đóng
            </Button>,
          ]}
          title="Chi tiết"
          style={{ top: 220 }}
        >
          {map(this.state.listCoin, (item, key) => (
            <div className="fontW-700 d-flex align-items mb-small">
              <div
                style={{
                  backgroundImage: `url(${get(this.props.coins, [
                    item.name_coin,
                    "icon_image",
                  ])}) `,
                  height: "25px",
                  width: "25px",
                  backgroundSize: "contain",
                  marginRight: "20px",
                  marginLeft: "20px",
                  display: "block",
                  backgroundRepeat: "no-repeat",
                }}
                alt={item.name_coin}
              />
              <div className="mr-small">{item.name_coin} </div>
              <div>{utils.formatCurrency(item.value)}</div>
            </div>
          ))}
        </Modal>
      </div>
    );
  }
}

export default AffiliateStatistic;
